type Props = {
  categoryLinks: JSX.Element[];
  subcategoryLinkDisplay?: JSX.Element;
};

const CategoryDisplay = ({
  categoryLinks,
  subcategoryLinkDisplay,
}: Props): JSX.Element => (
  <div className="pt-[64px]">
    <div className="overflow-x-auto whitespace-nowrap bg-dawn-blue-200 text-center">
      {categoryLinks}
    </div>
    {subcategoryLinkDisplay}
  </div>
);

export default CategoryDisplay;
